const Icons = [
  'icon-chevron-up',
  'icon-chevron-down',
  'icon-chevron-left',
  'icon-chevron-right',
  'icon-check-circle',
  'icon-alert-circle',
  'icon-info-circle',
  'icon-close-circle',
  'icon-close-circle-filled',
  'icon-touch-id',
  'icon-face-id',
  'icon-user',
  'icon-plus',
  'icon-close',
  'icon-pencil',
  'icon-chat',
  'icon-phone',
  'icon-cash',
  'icon-calendar',
  'icon-swap',
  'icon-more',
  'icon-menu',
  'icon-envelope',
  'icon-eye',
  'icon-eye-off'
]

export default Icons
